module.exports = __webpack_public_path__ + "img/rear.71aac8d6.png";